export const messages = {
    "shared-link.footer.link.install": "{brandName} kipróbálása díjmentesen",
    "shared-link.footer.link.mobile": "{brandName} mobilhoz",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Védett adatok",
    "shared-link.password-dialog-box.message": "Adja meg a jelszót a megosztott adatok eléréséhez",
    "shared-link.password-dialog-box.hint.password": "Jelszó",
    "shared-link.password-dialog-box.message.invalid-password": "A jelszó helytelen",
    "shared-link.form.button.open": "Megnyitás",
    "shared-link.page-not-found.title": "Nem található az oldal",
    "shared-link.page-not-found.message.main": "Nem található a keresett oldal.",
    "shared-link.page-not-found.message.description": "Lehet, hogy elavult a hivatkozás, esetleg rosszul írta be a címet.",
    "shared-link.page-not-found.message.error": "Hibakód: 404",
    "shared-link.restore-file.label.size": "Méret",
    "shared-link.restore-file.button.restore": "Letöltés",
    "shared-link.links-table.column.name": "Név",
    "shared-link.links-table.column.size": "Méret",
    "shared-link.links-table.action.restore": "Letöltés",
    "shared-link.links-table.action.restore-all": "Az összes letöltése",
    "shared-link.side-bar.selected.title:plural": "{count} elem kiválasztva | {count} elem kiválasztva | {count} elem kiválasztva",
    "shared-link.links-table.label.size": "Méret",
    "shared-link.links-table.message.empty-folder": "Ez a mappa üres"
};
